import PropTypes from "prop-types";

const GapButton = (props) => {
    const { buttonType, buttonClass, buttonLabel, onClick, disabled, id } = props;
    return (
        <button data-testid={id} type={buttonType} className={buttonClass} onClick={onClick} disabled={disabled}>{buttonLabel}</button>
    )
};

GapButton.propTypes = {
    buttonType: PropTypes.string,
    buttonClass: PropTypes.string,
    buttonLabel: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
}

export default GapButton;